import React from 'react';
import './footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} Gomoku - Five in a Row</p>
        <p>
          <a href="https://github.com/yourusername/gomoku" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;